import { TopProfessional } from '@/lib/api/dashboard/dashboard-api'
import { MdPerson } from 'react-icons/md'

interface TopProfessionalsChartProps {
    data: TopProfessional[]
}

export default function TopProfessionalsChart({ data }: TopProfessionalsChartProps) {
    const maxConsultations = Math.max(...data.map(p => p.consultations), 1)

    return (
        <div className="bg-base-100 rounded-xl border border-base-300/50 p-5">
            <h3 className="text-lg font-semibold text-base-content mb-4">
                Top Profissionais
            </h3>

            {data.length === 0 ? (
                <div className="flex items-center justify-center h-48 text-base-content/50">
                    Sem dados de profissionais
                </div>
            ) : (
                <div className="space-y-3">
                    {data.map((professional, index) => (
                        <div
                            key={professional.id}
                            className="flex items-center gap-3 p-2 rounded-lg hover:bg-base-200/50 transition-colors"
                        >
                            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-secondary/10 text-secondary font-bold text-sm">
                                {index + 1}
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="font-medium text-sm text-base-content truncate">
                                    {professional.name}
                                </p>
                                <p className="text-xs text-base-content/60">
                                    {professional.specialty || 'Geral'}
                                </p>
                            </div>
                            <div className="flex items-center gap-2">
                                <div className="w-24 h-2 bg-base-300/50 rounded-full overflow-hidden">
                                    <div
                                        className="h-full bg-secondary rounded-full transition-all"
                                        style={{
                                            width: `${(professional.consultations / maxConsultations) * 100}%`,
                                        }}
                                    />
                                </div>
                                <span className="text-sm font-bold text-base-content w-8 text-right">
                                    {professional.consultations}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}
